import { useContext } from "react";

import { BrandColorContext } from "./BrandColorContext";

export const useBrandColorContext = () => {
  return useContext(BrandColorContext);
};
